
import React from 'react';
import { FormGroup, FormLabel, FormError } from '@/components/ui/form-components';
import { Input } from '@/components/ui/input';
import { useListingForm } from '@/context/ListingFormContext';
import { Mail } from 'lucide-react';

const ListingEmailSection = () => {
  const { formData, errors, handleInputChange, isAuthenticated } = useListingForm();
  
  return (
    <div className="space-y-4 mb-8">
      <h2 className="text-lg font-semibold dark:text-white">Informacioni i kontaktit</h2>
      
      <FormGroup>
        <FormLabel required={!isAuthenticated}>Email-i juaj</FormLabel>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <Mail className="h-4 w-4 text-gray-400" />
          </div>
          <Input
            name="email"
            value={formData.email}
            onChange={(e) => handleInputChange('email', e.target.value)}
            placeholder="email@example.com"
            className={`pl-10 ${errors.email ? 'border-red-500' : ''}`}
            type="email"
          />
        </div>
        {errors.email && <FormError>{errors.email}</FormError>}
        <p className="text-xs text-gray-500 mt-1">
          {isAuthenticated 
            ? "Adresa e email-it është e nevojshme për të konfirmuar krijimin e shpalljes dhe për të komunikuar me blerësit."
            : "Adresa e email-it është e nevojshme për të konfirmuar krijimin e shpalljes, pasi ju nuk jeni të identifikuar."}
        </p>
      </FormGroup>
    </div>
  );
};

export default ListingEmailSection;
